// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"152":"949188cd","615":"2a4692c3","787":"eed8f647","797":"de723ca3","840":"8a084133","952":"908e7ee3"}[chunkId] + ".chunk.js";
};